export const ASSESSMENT_STATUS_BADGES = {
    in_progress: {
        label: "In progress",
        color: "#B26A00",
        backgroundColor: "#FFF4E5",
        icon: "ri-time-line"
    },
    completed: {
        label: "Completed",
        color: "#2E7D32",
        backgroundColor: "#E8F5E9",
        icon: "ri-checkbox-circle-fill"
    },
    not_started: {
        label: "Not started",
        color: "#828282",
        backgroundColor: "#F5F5F5",
        icon: "ri-indeterminate-circle-line"
    }
};

export const RISK_BADGES = {
    "Documentation Gap": {
        label: "Documentation Gap",
        color: "#B26A00",
        backgroundColor: "#FFF4E5"
    },
    "Assessment Gap": {
        label: "Assessment Gap",
        color: "#C05621",
        backgroundColor: "#FFF1E0"
    },
    "AI Risk": {
        label: "AI Risk",
        color: "#FFFFFF",
        backgroundColor: "#EB5757"
    }
};

export const PRIORITY_BADGES = {
    critical: {
        label: "Critical",
        color: "#FFFFFF",
        backgroundColor: "#9B1C1C"
    },
    high: {
        label: "High",
        color: "#FFFFFF",
        backgroundColor: "#EB5757"
    },
    medium: {
        label: "Medium",
        color: "#B26A00",
        backgroundColor: "#FFF4E5"
    },
    normal: {
        label: "Normal",
        color: "#1565C0",
        backgroundColor: "#E3F2FD"
    },
    low: {
        label: "Low",
        color: "#2E7D32",
        backgroundColor: "#E8F5E9"
    }
};

export const TASK_STATUS_BADGES = {
    New: {
        label: "New",
        color: "#3F51B5",
        backgroundColor: "#E8EAF6"
    }
};
